import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import StudioHeading from '../../../StudioHeading';
import PlaygroundTabs from '../../../playground/PlaygroundTabs';
import { getHasResults, getPlaygroundSubsection } from '../../../../selectors/studio';
import { PlaygroundSubsection } from '../../../../types/store';
import BaseHeader from '../BaseHeader';
import CreateWithWixelButton from './CreateWithWixelButton';
import CreateWithDrawButton from './CreateWithDrawButton';
import CreateWithDreamupButton from './CreateWithDreamupButton';
import VideoPointsBalance from './VideoPointsBalance';

interface Props {
  className?: string;
}

const PlaygroundHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const playgroundSubsection = useSelector(getPlaygroundSubsection);
  const isMobile = useContext(MobileContext);
  const hasDeviations = useSelector(getHasResults);

  return (
    <BaseHeader
      className={className}
      titleSlot={
        <>
          <StudioHeading>{t('studio.header.tabs.playground')}</StudioHeading>
          <PlaygroundTabs />
        </>
      }
      actions={
        !isMobile && (
          <>
            {hasDeviations && playgroundSubsection === PlaygroundSubsection.DreamUp && (
              <CreateWithDreamupButton />
            )}
            {hasDeviations && playgroundSubsection === PlaygroundSubsection.Draw && (
              <CreateWithDrawButton />
            )}
            {playgroundSubsection === PlaygroundSubsection.Video && <VideoPointsBalance />}
            {hasDeviations && playgroundSubsection === PlaygroundSubsection.Wixel && (
              <CreateWithWixelButton />
            )}
          </>
        )
      }
    />
  );
};

PlaygroundHeader.displayName = 'PlaygroundHeader';

export default PlaygroundHeader;
